import clsx from 'clsx';
import { useState } from 'react';
import type { SafeAny } from '@trg/utils';
import { IconButton, type IconButtonProps } from '@trg/tlw-ui-component';
import { useTrackingApi } from '../../api';
import { useProductCardContext } from './ProductCardContext';

export type FavoriteButtonProps = Omit<IconButtonProps, 'icon' | 'children'>;

export function FavoriteButton({
  className,
  onClick,
  ...porps
}: FavoriteButtonProps) {
  const { catalog, currentSwatch, isVertical, generateDataset } =
    useProductCardContext();

  const [isFavorite, setFavorite] = useState(currentSwatch.isTracking === 'Y');

  const { mutate, isLoading } = useTrackingApi(isFavorite ? 'remove' : 'add', {
    onSuccess: () => setFavorite(!isFavorite),
  });

  const handleClick: IconButtonProps['onClick'] = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (isLoading) return;
    onClick?.(e as SafeAny);
    mutate({ sku: currentSwatch.sku });
  };

  return (
    <IconButton
      className={clsx(
        isFavorite
          ? 'tlw-text-txt-core tlw-opacity-100'
          : 'tlw-text-txt-400 tlw-opacity-0 lg:group-hover/product-card:tlw-opacity-100',
        catalog && 'product__action__like',
        className
      )}
      icon="Heart"
      size={isVertical ? 'large' : 'medium'}
      square
      onClick={handleClick}
      {...porps}
      {...generateDataset('addToWishlist')}
    />
  );
}
